import { gql } from "@apollo/client";

export const MUTATION_DELETE_USER_TO_PROCESS_CALENDAR = gql`
  mutation MUTATION_DELETE_USER_TO_PROCESS_CALENDAR(
    $eventId: uuid!
  ) {
    delete_userToProcessCalendar_by_pk(id: $eventId) {
      id
    }
  }
`;

// ALECTINIB

export const ALECTINIB = gql`
  mutation ALECTINIB {
    insert_groupStage(
      objects: {
        comment: { en: "ALECTINIB", es: "ALECTINIB", fr: "ALECTINIB" }
        value: "alectinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "alectinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "alectinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "alectinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "alectinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "alectinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// AXITINIB

export const AXITINIB = gql`
  mutation AXITINIB {
    insert_groupStage(
      objects: {
        comment: { en: "AXITINIB", es: "AXITINIB", fr: "AXITINIB" }
        value: "axitinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "axitinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "axitinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "axitinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "axitinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "axitinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// BOLERO

export const BOLERO = gql`
  mutation BOLERO {
    insert_groupStage(
      objects: {
        comment: { en: "BOLERO", es: "BOLERO", fr: "BOLERO" }
        value: "bolero"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "boleroCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "boleroCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "boleroCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "boleroCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "boleroCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// CICLOFOSFAMIDA

export const CICLOFOSFAMIDA = gql`
  mutation CICLOFOSFAMIDA {
    insert_groupStage(
      objects: {
        comment: { en: "CICLOFOSFAMIDA", es: "CICLOFOSFAMIDA", fr: "CICLOFOSFAMIDA" }
        value: "ciclofosfamida"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "ciclofosfamidaCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "ciclofosfamidaCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "ciclofosfamidaCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "ciclofosfamidaCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "ciclofosfamidaCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// CRIZOTINIB

export const CRIZOTINIB = gql`
  mutation CRIZOTINIB {
    insert_groupStage(
      objects: {
        comment: { en: "CRIZOTINIB", es: "CRIZOTINIB", fr: "CRIZOTINIB" }
        value: "crizotinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "crizotinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "crizotinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "crizotinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "crizotinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "crizotinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// DABRAFENIB+TRAMETINIB

export const DABRAFENIB_TRAMETINIB = gql`
  mutation DABRAFENIB_TRAMETINIB {
    insert_groupStage(
      objects: {
        comment: { en: "DABRAFENIB+TRAMETINIB", es: "DABRAFENIB+TRAMETINIB", fr: "DABRAFENIB+TRAMETINIB" }
        value: "dabrafenib+trametinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "dabrafenibTrametinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// ERLOTINIB

export const ERLOTINIB = gql`
  mutation ERLOTINIB {
    insert_groupStage(
      objects: {
        comment: { en: "ERLOTINIB", es: "ERLOTINIB", fr: "ERLOTINIB" }
        value: "erlotinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "erlotinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "erlotinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "erlotinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "erlotinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "erlotinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// GEFITINIB

export const GEFITINIB = gql`
  mutation GEFITINIB {
    insert_groupStage(
      objects: {
        comment: { en: "GEFITINIB", es: "GEFITINIB", fr: "GEFITINIB" }
        value: "gefitinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "gefitinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "gefitinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "gefitinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "gefitinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "gefitinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// IMATINIB

export const IMATINIB = gql`
  mutation IMATINIB {
    insert_groupStage(
      objects: {
        comment: { en: "IMATINIB", es: "IMATINIB", fr: "IMATINIB" }
        value: "imatinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "imatinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "imatinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "imatinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "imatinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "imatinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// OLAPARIB

export const OLAPARIB = gql`
  mutation OLAPARIB {
    insert_groupStage(
      objects: {
        comment: { en: "OLAPARIB", es: "OLAPARIB", fr: "OLAPARIB" }
        value: "olaparib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "olaparibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "olaparibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "olaparibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "olaparibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "olaparibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// OSIMERTINIB

export const OSIMERTINIB = gql`
  mutation OSIMERTINIB {
    insert_groupStage(
      objects: {
        comment: { en: "OSIMERTINIB", es: "OSIMERTINIB", fr: "OSIMERTINIB" }
        value: "osimertinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "osimertinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "osimertinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "osimertinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "osimertinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "osimertinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// PAZOPANIB

export const PAZOPANIB = gql`
  mutation PAZOPANIB {
    insert_groupStage(
      objects: {
        comment: { en: "PAZOPANIB", es: "PAZOPANIB", fr: "PAZOPANIB" }
        value: "pazopanib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "pazopanibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "pazopanibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "pazopanibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "pazopanibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "pazopanibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// REGORAFENIB

export const REGORAFENIB = gql`
  mutation REGORAFENIB {
    insert_groupStage(
      objects: {
        comment: { en: "REGORAFENIB", es: "REGORAFENIB", fr: "REGORAFENIB" }
        value: "regorafenib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "regorafenibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "regorafenibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "regorafenibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "regorafenibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "regorafenibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// SIRULIMUS

export const SIRULIMUS = gql`
  mutation SIRULIMUS {
    insert_groupStage(
      objects: {
        comment: { en: "SIRULIMUS", es: "SIRULIMUS", fr: "SIRULIMUS" }
        value: "sirulimus"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sirulimusCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sirulimusCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sirulimusCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sirulimusCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sirulimusCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// SORAFENIB

export const SORAFENIB = gql`
  mutation SORAFENIB {
    insert_groupStage(
      objects: {
        comment: { en: "SORAFENIB", es: "SORAFENIB", fr: "SORAFENIB" }
        value: "sorafenib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sorafenibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sorafenibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sorafenibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sorafenibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sorafenibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// SUNITINIB

export const SUNITINIB = gql`
  mutation SUNITINIB {
    insert_groupStage(
      objects: {
        comment: { en: "SUNITINIB", es: "SUNITINIB", fr: "SUNITINIB" }
        value: "sunitinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sunitinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sunitinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sunitinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "sunitinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "sunitinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// VEMURAFENIB + COBIMETINIB

export const VEMURAFENIB_COBIMETINIB = gql`
  mutation VEMURAFENIB_COBIMETINIB {
    insert_groupStage(
      objects: {
        comment: { en: "VEMURAFENIB + COBIMETINIB", es: "VEMURAFENIB + COBIMETINIB", fr: "VEMURAFENIB + COBIMETINIB" }
        value: "vemurafenib + cobimetinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vemurafenibCobimetinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// VISMODEGIB

export const VISMODEGIB = gql`
  mutation VISMODEGIB {
    insert_groupStage(
      objects: {
        comment: { en: "VISMODEGIB", es: "VISMODEGIB", fr: "VISMODEGIB" }
        value: "vismodegib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vismodegibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vismodegibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vismodegibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "vismodegibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "vismodegibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// XP

export const XP = gql`
  mutation XP {
    insert_groupStage(
      objects: {
        comment: { en: "XP", es: "XP", fr: "XP" }
        value: "xp"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "xpCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "xpCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "xpCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "xpCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "xpCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// LENVATINIB

export const LENVATINIB = gql`
  mutation LENVATINIB {
    insert_groupStage(
      objects: {
        comment: { en: "LENVATINIB", es: "LENVATINIB", fr: "LENVATINIB" }
        value: "lenvatinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lenvatinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lenvatinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lenvatinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lenvatinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lenvatinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// ABEMACICLIB

export const ABEMACICLIB = gql`
  mutation ABEMACICLIB {
    insert_groupStage(
      objects: {
        comment: { en: "ABEMACICLIB", es: "ABEMACICLIB", fr: "ABEMACICLIB" }
        value: "abemaciclib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "abemaciclibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "abemaciclibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "abemaciclibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "abemaciclibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "abemaciclibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// NIRAPARIB

export const NIRAPARIB = gql`
  mutation NIRAPARIB {
    insert_groupStage(
      objects: {
        comment: { en: "NIRAPARIB", es: "NIRAPARIB", fr: "NIRAPARIB" }
        value: "niraparib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "niraparibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "niraparibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "niraparibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "niraparibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "niraparibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// CABOSANTINIB

export const CABOSANTINIB = gql`
  mutation CABOSANTINIB {
    insert_groupStage(
      objects: {
        comment: { en: "CABOSANTINIB", es: "CABOSANTINIB", fr: "CABOSANTINIB" }
        value: "cabosantinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "cabosantinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "cabosantinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "cabosantinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "cabosantinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "cabosantinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// LORLATINIB

export const LORLATINIB = gql`
  mutation LORLATINIB {
    insert_groupStage(
      objects: {
        comment: { en: "LORLATINIB", es: "LORLATINIB", fr: "LORLATINIB" }
        value: "lorlatinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lorlatinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lorlatinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lorlatinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "lorlatinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "lorlatinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// SELPERCATINIB

export const SELPERCATINIB = gql`
  mutation SELPERCATINIB {
    insert_groupStage(
      objects: {
        comment: { en: "SELPERCATINIB", es: "SELPERCATINIB", fr: "SELPERCATINIB" }
        value: "selpercatinib"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "selpercatinibCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "selpercatinibCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "selpercatinibCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "selpercatinibCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "selpercatinibCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// ENZALUTAMIDA

export const ENZALUTAMIDA = gql`
  mutation ENZALUTAMIDA {
    insert_groupStage(
      objects: {
        comment: { en: "ENZALUTAMIDA", es: "ENZALUTAMIDA", fr: "ENZALUTAMIDA" }
        value: "enzalutamida"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "enzalutamidaCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "enzalutamidaCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "enzalutamidaCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "enzalutamidaCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "enzalutamidaCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// ENCORAFENIB + CETUXIMAB

export const ENCORAFENIB_CETUXIMAB = gql`
  mutation ENCORAFENIB_CETUXIMAB {
    insert_groupStage(
      objects: {
        comment: { en: "ENCORAFENIB + CETUXIMAB", es: "ENCORAFENIB + CETUXIMAB", fr: "ENCORAFENIB + CETUXIMAB" }
        value: "encorafenib + cetuximab"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "encorafenibCetuximabCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "encorafenibCetuximabCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "encorafenibCetuximabCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "encorafenibCetuximabCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "encorafenibCetuximabCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;

// EVEROLIMUS

export const EVEROLIMUS = gql`
  mutation EVEROLIMUS {
    insert_groupStage(
      objects: {
        comment: { en: "EVEROLIMUS", es: "EVEROLIMUS", fr: "EVEROLIMUS" }
        value: "everolimus"
        processStages: {
          data: [
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "everolimusCycle1"
              processId: 47
              stageName: { en: "Cycle 1", es: "Ciclo 1" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "everolimusCycle2"
              processId: 47
              stageName: { en: "Cycle 2", es: "Ciclo 2" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "everolimusCycle3"
              processId: 47
              stageName: { en: "Cycle 3", es: "Ciclo 3" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 30
              frequencyType: "days"
              isAutomatic: false
              id: "everolimusCycle4"
              processId: 47
              stageName: { en: "Cycle 4", es: "Ciclo 4" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle5"
              processId: 47
              stageName: { en: "Cycle 5", es: "Ciclo 5" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 2
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle6"
              processId: 47
              stageName: { en: "Cycle 6", es: "Ciclo 6" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle7"
              processId: 47
              stageName: { en: "Cycle 7", es: "Ciclo 7" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle8"
              processId: 47
              stageName: { en: "Cycle 8", es: "Ciclo 8" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle9"
              processId: 47
              stageName: { en: "Cycle 9", es: "Ciclo 9" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle10"
              processId: 47
              stageName: { en: "Cycle 10", es: "Ciclo 10" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle11"
              processId: 47
              stageName: { en: "Cycle 11", es: "Ciclo 11" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle12"
              processId: 47
              stageName: { en: "Cycle 12", es: "Ciclo 12" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle13"
              processId: 47
              stageName: { en: "Cycle 13", es: "Ciclo 13" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle14"
              processId: 47
              stageName: { en: "Cycle 14", es: "Ciclo 14" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle15"
              processId: 47
              stageName: { en: "Cycle 15", es: "Ciclo 15" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle16"
              processId: 47
              stageName: { en: "Cycle 16", es: "Ciclo 16" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle17"
              processId: 47
              stageName: { en: "Cycle 17", es: "Ciclo 17" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle18"
              processId: 47
              stageName: { en: "Cycle 18", es: "Ciclo 18" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle19"
              processId: 47
              stageName: { en: "Cycle 19", es: "Ciclo 19" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle20"
              processId: 47
              stageName: { en: "Cycle 20", es: "Ciclo 20" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle21"
              processId: 47
              stageName: { en: "Cycle 21", es: "Ciclo 21" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle22"
              processId: 47
              stageName: { en: "Cycle 22", es: "Ciclo 22" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle23"
              processId: 47
              stageName: { en: "Cycle 23", es: "Ciclo 23" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle24"
              processId: 47
              stageName: { en: "Cycle 24", es: "Ciclo 24" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle25"
              processId: 47
              stageName: { en: "Cycle 25", es: "Ciclo 25" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle26"
              processId: 47
              stageName: { en: "Cycle 26", es: "Ciclo 26" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle27"
              processId: 47
              stageName: { en: "Cycle 27", es: "Ciclo 27" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle28"
              processId: 47
              stageName: { en: "Cycle 28", es: "Ciclo 28" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle29"
              processId: 47
              stageName: { en: "Cycle 29", es: "Ciclo 29" }
            }
            {
              descript: {
                icon: "/maiaFigures/responseRateComplete.svg"
                color: "#7DD65E"
              }
              frequency: 4
              frequencyType: "months"
              isAutomatic: false
              id: "everolimusCycle30"
              processId: 47
              stageName: { en: "Cycle 30", es: "Ciclo 30" }
            }
          ]
        }
      }
    ) {
      returning {
        comment
        value
        processStages {
          descript
          frequency
          frequencyType
          groupStageValue
          id
          isAutomatic
          nextStageId
          processId
          stageName
        }
      }
    }
  }
`;
